const BRANDS = [
  "Reliance Industries",
  "Advent India PE",
  "Aditya Birla Group",
  "Dr. Reddy's",
  "Raymond",
  "Onida",
  "Indian Navy",
  "Zima Gourmet",
  "Lotus Royale",
  "Elegant Marbles",
  "Kink Cafe",
  "Radiance Skin Clinic",
  "DHR Global",
  "Indorient",
  "Digiosmosis",
  "AKFC",
  "Kindness Practice Foundation",
  "Etherwire AI",
  "DR&W Studio",
  "Architect Mahek Aga",
  "MLA Ram Kadam",
];

export default function BrandMarquee() {
  // duplicate the list so the loop is seamless
  const items = [...BRANDS, ...BRANDS];
  return (
    <section
      data-testid="brand-marquee-section"
      className="relative w-full bg-[#F9F8F6] border-y border-[#E5E1DB] py-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 mb-6 flex items-center justify-between">
        <p className="text-[10px] sm:text-[11px] tracking-[0.4em] uppercase text-[#5C6658]">
          02 / In good company
        </p>
        <p className="hidden sm:block text-[10px] tracking-[0.4em] uppercase text-[#5C6658]">
          Esteemed clients
        </p>
      </div>

      <div className="relative w-full overflow-hidden">
        {/* gradient masks for edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#F9F8F6] to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#F9F8F6] to-transparent" />

        <div className="ig-marquee-track flex whitespace-nowrap will-change-transform">
          {items.map((b, i) => (
            <span
              key={i}
              data-testid={`brand-${i}`}
              className="inline-flex items-center mx-10 sm:mx-16 text-[#8A9A86] font-[DM_Sans] text-[18px] sm:text-[22px] tracking-[0.35em] uppercase font-light"
            >
              {b}
              <span className="ml-10 sm:ml-16 inline-block w-1 h-1 rounded-full bg-[#B4C2AF] align-middle" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
